<template>




  <div class="item">
    <img src="https://nossavisao.pt/nossanew/wp/wp-content/uploads/DSC09310.jpg" class="js-image" ref="img" alt="">

  </div>

</template>

<script>
// import { Clock, PerspectiveCamera, Scene, WebGLRenderer } from 'three'
import * as THREE from 'three'
import TrackballControls from 'three-trackballcontrols'

import {
  BloomEffect,
  EffectComposer,
  GlitchPass,
  EffectPass,
  RenderPass
} from 'postprocessing'

export default {
  name: 'choca',
  data: function() {
    const scene = new THREE.Scene()
    // const composer = new THREE.EffectComposer(new WebGLRenderer())
    // const effectPass = new THREE.EffectPass(camera, new BloomEffect())
    const camera = new THREE.PerspectiveCamera(
        75,
        window.innerWidth / window.innerHeight,
        0.1,
        1000
    )
    const renderer = new THREE.WebGLRenderer({ antialias: true })
    const light = new THREE.DirectionalLight('hsl(0, 100%, 100%)')
    const geometry = new THREE.PlaneGeometry( 0.45, 0.3);
    const material = {}
    const cube = new THREE.Mesh(geometry, material)
    const axes = new THREE.AxesHelper(5)
    const img =  {};
    const texture = {};

    return {
      scene: scene,
      camera: camera,

      renderer: renderer,
      light: light,
      cube: cube,
      axes: axes,
      speed: 0.01,
      img: img,
      texture: texture
    }
  },
  created: function() {
    this.scene.add(this.camera)
    this.scene.add(this.light)
    this.scene.add(this.cube)
    this.scene.add(this.axes)
    this.renderer.setSize(window.innerWidth, window.innerHeight)
    this.light.position.set(0, 0, 10)
    this.camera.position.z = 5
    this.scene.background = new THREE.Color('hsl(0, 100%, 100%)')

  },
  mounted: function() {
    const _this = this;

    let dummyimg = document.createElement("img");
    dummyimg.onload = function(){
     // document.body.classList.remove('loading')
      _this.img.style.opacity = 0;
      _this.texture = new THREE.Texture( this );
      _this.texture.needsUpdate = true;

      console.log('....')

      _this.animate()
    }




    _this.img =  _this.$refs.img
    dummyimg.src = _this.img.src;
  //  this.$refs.canvas.appendChild(this.renderer.domElement)

  },
  methods: {
    animate: function() {
      console.log('ss')
      requestAnimationFrame(this.animate)



    }
  },
  computed: {


  }
}
</script>


©


// WEBPACK FOOTER //
// src/components/Choca.vue